import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ticket-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "ticket-watermark"
}
const _hoisted_3 = {
  key: 1,
  class: "ticket-watermark ticket-watermark--credit"
}
const _hoisted_4 = { class: "ticket-header text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "ticket-logo"
}
const _hoisted_7 = { class: "ticket-title mb-1" }
const _hoisted_8 = {
  key: 2,
  class: "ticket-legal-name"
}
const _hoisted_9 = { class: "ticket-subtitle mb-0" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "ticket-meta mb-0" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { class: "ticket-body" }
const _hoisted_20 = { class: "ticket-table" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = {
  key: 0,
  class: "ticket-promo-label"
}
const _hoisted_23 = {
  key: 1,
  class: "ticket-promo-label"
}
const _hoisted_24 = {
  key: 2,
  class: "ticket-coefficient-label"
}
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = {
  key: 0,
  class: "ticket-price-strike"
}
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "ticket-totals" }
const _hoisted_30 = { class: "d-flex justify-content-between" }
const _hoisted_31 = { class: "d-flex justify-content-between" }
const _hoisted_32 = { class: "d-flex justify-content-between" }
const _hoisted_33 = { class: "d-flex justify-content-between" }
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = {
  key: 1,
  class: "d-flex justify-content-between"
}
const _hoisted_36 = {
  key: 2,
  class: "d-flex justify-content-between"
}
const _hoisted_37 = {
  key: 3,
  class: "d-flex justify-content-between"
}
const _hoisted_38 = { class: "d-flex justify-content-between" }
const _hoisted_39 = {
  key: 4,
  class: "d-flex justify-content-between"
}
const _hoisted_40 = {
  key: 5,
  class: "d-flex justify-content-between"
}
const _hoisted_41 = {
  key: 6,
  class: "d-flex justify-content-between"
}
const _hoisted_42 = {
  key: 7,
  class: "d-flex justify-content-between"
}
const _hoisted_43 = {
  key: 8,
  class: "d-flex justify-content-between"
}
const _hoisted_44 = {
  key: 9,
  class: "d-flex justify-content-between"
}
const _hoisted_45 = { class: "ticket-footer text-center" }
const _hoisted_46 = { class: "mb-1" }
const _hoisted_47 = {
  key: 0,
  class: "ticket-opening-hours"
}
const _hoisted_48 = {
  key: 1,
  class: "ticket-signature"
}
const _hoisted_49 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["ticket ticket--high-contrast-print", { 'ticket--duplicate': _ctx.duplicate }])
    }, [
      (_ctx.duplicate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "DUPLICATA"))
        : _createCommentVNode("", true),
      (_ctx.isCreditTicket)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "À CRÉDIT"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.ticketLogo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.ticketLogo,
              alt: "Logo",
              class: "ticket-logo-image",
              onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTicketLogoError && _ctx.handleTicketLogoError(...args)))
            }, null, 40, _hoisted_5))
          : (_ctx.logoText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.logoText), 1))
            : _createCommentVNode("", true),
        _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.ticketBusinessName), 1),
        (_ctx.ticketLegalName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.ticketLegalName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_9, [
          (_ctx.ticketAddress)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.ticketAddress), 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.ticketPhone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.ticketPhone), 1))
            : _createCommentVNode("", true),
          (_ctx.ticketEmail)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.ticketEmail), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.ticketTaxId)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createTextVNode("NIF : " + _toDisplayString(_ctx.ticketTaxId), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
        _createElementVNode("p", _hoisted_14, [
          _cache[7] || (_cache[7] = _createTextVNode(" Ticket n° ", -1)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.sale.reference), 1),
          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
          (_ctx.sale.daily_position)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _cache[4] || (_cache[4] = _createTextVNode("Position : ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.sale.daily_position), 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" Date : " + _toDisplayString(_ctx.$format.date(_ctx.sale.created_at)), 1),
          (_ctx.sale.ticket_last_printed_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " " + _toDisplayString(_ctx.formatPrintedTime(_ctx.sale.ticket_last_printed_at)), 1))
            : _createCommentVNode("", true),
          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
          (_ctx.cashierName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Caissier : " + _toDisplayString(_ctx.cashierName), 1))
            : _createCommentVNode("", true),
          (_ctx.cashRegisterName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _createTextVNode("Caisse : " + _toDisplayString(_ctx.cashRegisterName), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[30] || (_cache[30] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("table", _hoisted_20, [
          _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "text-start" }, "Désignation"),
              _createElementVNode("th", { class: "text-end" }, "Qté"),
              _createElementVNode("th", { class: "text-end" }, "PU"),
              _createElementVNode("th", { class: "text-end" }, "Total")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeItems, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_21, [
                  _createTextVNode(_toDisplayString(item.product_name) + " ", 1),
                  (_ctx.isPromotionLine(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(item.price_source === 'cashier_promotion' ? 'Promo caisse' : 'Promotion'), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isFormulaLine(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Formule " + _toDisplayString(item.formula_quantity) + " pour " + _toDisplayString(_ctx.formatLineAmount(item.formula_price || 0)), 1))
                    : _createCommentVNode("", true),
                  (item.sale_price_coefficient !== null && item.sale_price_coefficient !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Coef. " + _toDisplayString(_ctx.coefficientLabel(item.sale_price_coefficient)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.remainingQuantity(item)), 1),
                _createElementVNode("td", _hoisted_26, [
                  (_ctx.isPromotionLine(item))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.formatLineAmount(item.base_unit_price || item.unit_price)), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatLineAmount(item.unit_price)), 1)
                ]),
                _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.formatLineAmount(_ctx.activeLineTotal(item))), 1)
              ]))
            }), 128))
          ])
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
        _createElementVNode("div", _hoisted_29, [
          (_ctx.sale.wallet_transaction)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", null, "Portefeuille", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.sale.wallet_transaction.wallet?.name || 'Électronique'), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "Opération", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.walletOperationLabel), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "Référence", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.sale.wallet_transaction.reference), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", null, "Solde après", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.wallet_transaction.balance_after)), 1)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "Sous-total", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.subtotal_amount || _ctx.sale.total_amount || 0)), 1)
          ]),
          (Number(_ctx.sale.discount_amount || 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "Remise", -1)),
                _createElementVNode("span", null, "- " + _toDisplayString(_ctx.$format.currency(_ctx.sale.discount_amount || 0)), 1)
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.sale.tva_amount || 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "TVA incluse", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.tva_amount || 0)), 1)
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.sale.css_amount || 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _cache[19] || (_cache[19] = _createElementVNode("span", null, "CSS incluse", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.css_amount || 0)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Total net", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.total_amount)), 1)
          ]),
          (_ctx.sale.payment_method)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "Paiement", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.paymentMethodLabel(_ctx.sale.payment_method)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.sale.payment_method === 'credit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "Reste dû", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.credit_due_amount || 0)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.sale.payment_reference)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _cache[23] || (_cache[23] = _createElementVNode("span", null, "Référence", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.sale.payment_reference), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.sale.payment_method === 'cash' && _ctx.sale.amount_received != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _cache[24] || (_cache[24] = _createElementVNode("span", null, "Reçu", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.amount_received)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.sale.payment_method === 'cash' && _ctx.sale.amount_returned != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _cache[25] || (_cache[25] = _createElementVNode("span", null, "Rendu", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$format.currency(_ctx.sale.amount_returned)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.sale.customer_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[26] || (_cache[26] = _createElementVNode("span", null, "Client", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.sale.customer_name), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.ticketFooterNote), 1),
        _createElementVNode("small", null, _toDisplayString(_ctx.ticketBusinessName), 1),
        (_ctx.ticketOpeningHours.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Horaires d’ouverture", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketOpeningHours, (hours) => {
                return (_openBlock(), _createElementBlock("span", { key: hours }, _toDisplayString(hours), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "ticket-powered-by" }, "powered by Suite241", -1)),
        (_ctx.ticketSignatureValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", { innerHTML: _ctx.ticketSignatureBarcode }, null, 8, _hoisted_49),
              _createElementVNode("small", null, "Signature : " + _toDisplayString(_ctx.ticketSignatureValue), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}